/**
 * ISO 3166-1 alpha-2 country codes mapped to Norwegian country names.
 *
 * To regenerate this list, you can use the `i18n-iso-countries` npm package:
 *   import countries from "i18n-iso-countries"
 *   import nb from "i18n-iso-countries/langs/nb.json"
 *   countries.registerLocale(nb)
 *   const names = countries.getNames("nb", { select: "official" })
 *   console.log(JSON.stringify(names, null, 2))
 */

export const countriesNb: Record<string, string> = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algerie",
  AS: "Amerikansk Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarktis",
  AG: "Antigua og Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AZ: "Aserbajdsjan",
  AU: "Australia",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BE: "Belgia",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius og Saba",
  BA: "Bosnia-Hercegovina",
  BW: "Botswana",
  BR: "Brasil",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  CA: "Canada",
  KY: "Caymanøyene",
  CL: "Chile",
  CO: "Colombia",
  CK: "Cookøyene",
  CR: "Costa Rica",
  CU: "Cuba",
  CW: "Curaçao",
  DK: "Danmark",
  VI: "De amerikanske Jomfruøyene",
  VG: "De britiske Jomfruøyene",
  AE: "De forente arabiske emirater",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Den dominikanske republikk",
  EC: "Ecuador",
  EG: "Egypt",
  GQ: "Ekvatorial-Guinea",
  SV: "El Salvador",
  CI: "Elfenbenskysten",
  ER: "Eritrea",
  EE: "Estland",
  SZ: "Eswatini",
  ET: "Etiopia",
  FK: "Falklandsøyene",
  FJ: "Fiji",
  PH: "Filippinene",
  FI: "Finland",
  FR: "Frankrike",
  GF: "Fransk Guyana",
  PF: "Fransk Polynesia",
  TF: "Franske sørlige og antarktiske territorier",
  FO: "Færøyene",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  GH: "Ghana",
  GI: "Gibraltar",
  GD: "Grenada",
  GL: "Grønland",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HN: "Honduras",
  HK: "Hongkong",
  IN: "India",
  ID: "Indonesia",
  IQ: "Irak",
  IR: "Iran",
  IE: "Irland",
  IS: "Island",
  IL: "Israel",
  IT: "Italia",
  JM: "Jamaica",
  JP: "Japan",
  YE: "Jemen",
  JE: "Jersey",
  JO: "Jordan",
  CX: "Juleholmen",
  KH: "Kambodsja",
  CM: "Kamerun",
  CV: "Kapp Verde",
  KZ: "Kasakhstan",
  KE: "Kenya",
  CN: "Kina",
  KG: "Kirgisistan",
  KI: "Kiribati",
  CC: "Kokosøyene",
  KM: "Komorene",
  CD: "Kongo, Den demokratiske republikken",
  CG: "Kongo, Republikken",
  HR: "Kroatia",
  KW: "Kuwait",
  CY: "Kypros",
  LA: "Laos",
  LV: "Latvia",
  LS: "Lesotho",
  LB: "Libanon",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Litauen",
  LU: "Luxembourg",
  MO: "Macao",
  MG: "Madagaskar",
  MK: "Makedonia, Republikken Nord-",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldivene",
  ML: "Mali",
  MT: "Malta",
  IM: "Man",
  MA: "Marokko",
  MH: "Marshalløyene",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Mikronesia",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MZ: "Mosambik",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NL: "Nederland",
  NP: "Nepal",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  KP: "Nord-Korea",
  MP: "Nord-Marianene",
  NF: "Norfolkøya",
  NO: "Norge",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestina",
  PA: "Panama",
  PG: "Papua Ny-Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PN: "Pitcairnøyene",
  PL: "Polen",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russland",
  RW: "Rwanda",
  BL: "Saint-Barthélemy",
  SH: "Saint Helena, Ascension og Tristan da Cunha",
  KN: "Saint Kitts og Nevis",
  LC: "Saint Lucia",
  MF: "Saint-Martin",
  PM: "Saint-Pierre og Miquelon",
  VC: "Saint Vincent og Grenadinene",
  SB: "Salomonøyene",
  WS: "Samoa",
  SM: "San Marino",
  ST: "São Tomé og Príncipe",
  SA: "Saudi-Arabia",
  CH: "Sveits",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychellene",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SO: "Somalia",
  ES: "Spania",
  LK: "Sri Lanka",
  GB: "Storbritannia",
  SD: "Sudan",
  SR: "Surinam",
  SJ: "Svalbard og Jan Mayen",
  SE: "Sverige",
  SY: "Syria",
  ZA: "Sør-Afrika",
  GS: "Sør-Georgia og Sør-Sandwichøyene",
  KR: "Sør-Korea",
  SS: "Sør-Sudan",
  TJ: "Tadsjikistan",
  TW: "Taiwan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad og Tobago",
  TD: "Tsjad",
  CZ: "Tsjekkia",
  TN: "Tunisia",
  TM: "Turkmenistan",
  TC: "Turks- og Caicosøyene",
  TV: "Tuvalu",
  TR: "Tyrkia",
  DE: "Tyskland",
  UG: "Uganda",
  UA: "Ukraina",
  HU: "Ungarn",
  UY: "Uruguay",
  US: "USA",
  UZ: "Usbekistan",
  VU: "Vanuatu",
  VA: "Vatikanstaten",
  VE: "Venezuela",
  EH: "Vest-Sahara",
  VN: "Vietnam",
  WF: "Wallis og Futuna",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  AT: "Østerrike",
  TL: "Øst-Timor",
  IO: "Det britiske territoriet i Indiahavet",
  UM: "USAs ytre småøyer",
  AX: "Åland",
}

/** Sorted array of { code, name } for use in dropdowns */
export const countryOptionsNb: Array<{ code: string; name: string }> = Object.entries(countriesNb)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, "nb"))

/** Look up Norwegian country name by ISO alpha-2 code */
export function getCountryNameNb(code: string): string | undefined {
  return countriesNb[code]
}
